export const CHAT_TILE_ID = 'ai-chat';
export const CHAT_TILE_WIDTH = '432px';
export const CHAT_BAR_HEIGHT_PX = 55;

// Shared layoutId for framer-motion `LayoutGroup` pill morph between tiles.
export const COMPOSER_LAYOUT_ID = 'chat-composer';

export const COMPOSER_TRANSITION = { duration: 0.35, ease: 'easeInOut' as const };
